// frontend/src/features/content/contentSlice.js
import { createSlice } from '@reduxjs/toolkit';

const contentSlice = createSlice({
    name: 'content',
    initialState: {
        pageNumber: 1,
        searchQuery: '',
        isActiveFilter: '',
        categoryFilter: '',
        ClanguageFilter: '', // ✅ सुनिश्चित करें कि यह यहाँ है
    },
    reducers: {
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        setIsActiveFilter: (state, action) => {
            state.isActiveFilter = action.payload;
        },
        setCategoryFilter: (state, action) => {
            state.categoryFilter = action.payload;
        },
        setClanguageFilter: (state, action) => { // ✅ सुनिश्चित करें कि यह रिड्यूसर यहाँ है
            state.ClanguageFilter = action.payload;
        },
        resetContentListState: (state) => {
            state.pageNumber = 1;
            state.searchQuery = '';
            state.isActiveFilter = '';
            state.categoryFilter = '';
            state.ClanguageFilter = ''; // ✅ सुनिश्चित करें कि यह रीसेट में है
        },
    },
});

export const {
    setPageNumber,
    setSearchQuery,
    setIsActiveFilter,
    setCategoryFilter,
    setClanguageFilter, // ✅ इसे भी एक्सपोर्ट करें
    resetContentListState
} = contentSlice.actions;

export default contentSlice.reducer;